/**
 * @description 包装外呼jssdk的抽象类
 */
export default class AbstractVendor {
  bind() {}

  onDialOut(callback) {}

  /**
   * @description 监听拨打电话相关的状态，仅关注以下状态
   //外呼坐席振铃事件
   case "EVENT_OUTBOUND_ALERTING_TP":
   //外呼坐席接通事件
   case "EVENT_OUTBOUND_CONNECTED_OP":
   //坐席挂断事件
   case "EVENT_TP_DISCONNECT":
   //客户挂断事件
   case "EVENT_OP_DISCONNECT":
   */
  onDialStatusUpdate(callback) {}

  /**
   * @description 监听登录登出、是否占线相关的状态
   * @param callback
   */
  onUpdateStatus(callback) {}

  /**
   * @description 展示面板
   */
  autoShowPanel() {}

  login() {}

  /**
   * @description 命令式主动调起呼叫
   * @param number 手机号
   * @param params {leadId, contactId}
   */
  dialOut(number, params) {}
}
